<!-- ===== REFONTE : éditeur de lieux et sessions ===== -->
<div class="se-root">
  <!-- Créneaux par défaut -->
  <div class="se-defaults">
    <span class="se-label font-medium inter-medium f14 color-gray-700"
      >Créneaux par défaut</span
    >
    <p class="se-hint">Appliqués automatiquement à chaque nouveau jour.</p>

    <div class="se-chips">
      <span *ngFor="let c of creneauxParDefaut; let i = index" class="se-chip">
        {{ c.debut }} – {{ c.fin }}
        <button
          type="button"
          (click)="retirerCreneauParDefaut(i)"
          aria-label="Retirer ce créneau"
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>
      </span>

      <span class="se-add-default">
        <input
          type="time"
          class="se-input se-input-sm"
          [formControl]="nouveauDebut"
          aria-label="Début"
        />
        <span class="se-dash">–</span>
        <input
          type="time"
          class="se-input se-input-sm"
          [formControl]="nouveauFin"
          aria-label="Fin"
        />
        <button
          type="button"
          class="se-btn-ghost"
          (click)="ajouterCreneauParDefaut()"
        >
          Ajouter
        </button>
      </span>
    </div>
  </div>

  <!-- ===== DÉBUT MODIF : aucune ville, en erreur après un clic sur Sauvegarder ===== -->
  <div
    class="se-empty"
    *ngIf="lieux.length === 0"
    [class.is-invalid]="
      lieuxArray.touched && lieuxArray.hasError('minLengthArray')
    "
  >
    <p>Aucune ville pour l'instant.</p>
    <p
      *ngIf="
        lieuxArray.touched && lieuxArray.hasError('minLengthArray');
        else aideVille
      "
      class="se-error"
    >
      Ajoute au moins une ville, avec ses jours et ses créneaux.
    </p>
    <ng-template #aideVille>
      <p class="se-hint">
        Ajoute au moins une ville, avec ses jours et ses créneaux.
      </p>
    </ng-template>
  </div>
  <!-- ===== FIN MODIF ===== -->

  <!-- Une carte par ville -->
  <div
    *ngFor="let lieu of lieux; let li = index"
    [formGroup]="lieu"
    class="se-city"
    [class.is-invalid]="
      lieu.errors?.['chevauchement'] ||
      (lieu.get('ville')?.invalid && lieu.get('ville')?.touched)
    "
  >
    <!-- En-tête de la ville -->
    <div class="se-city-head">
      <select
        formControlName="ville"
        class="se-input se-city-select"
        aria-label="Ville"
      >
        <option value="" disabled>Choisir la ville</option>
        <option *ngFor="let v of villesDisponibles(li)" [value]="v.name">
          {{ v.name }}
        </option>
      </select>
      <span class="se-hint">
        {{ jours(lieu).length }} jour(s) · {{ nbCreneaux(lieu) }} créneau(x)
      </span>
      <button
        type="button"
        class="se-icon-btn se-danger"
        (click)="supprimerLieu(li)"
        aria-label="Supprimer la ville"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" />
        </svg>
      </button>
    </div>

    <!-- Chevauchement -->
    <div *ngIf="lieu.errors?.['chevauchement'] as err" class="se-alert">
      <strong>Créneaux en chevauchement le {{ err.date }} :</strong>
      {{ err.creneau1 }} et {{ err.creneau2 }}.<br />
      Une activité ne peut pas avoir deux sessions en même temps dans la même
      ville. Modifie les horaires, ou crée une
      <strong>activité séparée</strong> pour la session en parallèle.
    </div>

    <!-- Jours -->
    <div formArrayName="jours" class="se-days">
      <div class="se-day-labels" *ngIf="jours(lieu).length">
        <span>Date</span><span>Salle</span><span>Créneaux</span><span></span>
      </div>

      <div
        *ngFor="let jour of jours(lieu).controls; let ji = index"
        [formGroupName]="ji"
        class="se-day"
      >
        <input
          type="date"
          formControlName="date"
          class="se-input"
          [min]="minDate"
          [max]="maxDate"
          [class.is-invalid]="
            jour.get('date')?.invalid && jour.get('date')?.touched
          "
          aria-label="Date"
        />

        <input
          type="text"
          formControlName="salle"
          class="se-input"
          placeholder="Salle (ex. CEDEPS)"
          aria-label="Salle"
        />

        <div formArrayName="creneaux" class="se-slots">
          <div
            *ngFor="let c of creneaux(jour).controls; let ci = index"
            [formGroupName]="ci"
            class="se-slot"
          >
            <input
              type="time"
              formControlName="debut"
              class="se-input se-input-sm"
              [class.is-invalid]="c.invalid && c.touched"
              aria-label="Début"
            />
            <span class="se-dash">–</span>
            <input
              type="time"
              formControlName="fin"
              class="se-input se-input-sm"
              [class.is-invalid]="c.invalid && c.touched"
              aria-label="Fin"
            />
            <button
              type="button"
              class="se-icon-btn"
              (click)="supprimerCreneau(jour, ci)"
              aria-label="Retirer ce créneau"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <path d="M6 6l12 12M18 6L6 18" />
              </svg>
            </button>
            <span *ngIf="c.hasError('heuresInvalides')" class="se-error"
              >La fin doit être après le début</span
            >
          </div>
          <button type="button" class="se-link" (click)="ajouterCreneau(jour)">
            + Ajouter un créneau
          </button>
        </div>

        <button
          type="button"
          class="se-icon-btn se-danger"
          (click)="supprimerJour(lieu, ji)"
          aria-label="Retirer ce jour"
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" />
          </svg>
        </button>
      </div>

      <p class="se-error" *ngIf="jours(lieu).length === 0">
        Ajoute au moins un jour.
      </p>
    </div>

    <!-- Actions de la ville -->
    <div class="se-city-actions">
      <button type="button" class="se-btn-ghost" (click)="ajouterJour(lieu)">
        + Ajouter un jour
      </button>
      <button
        type="button"
        class="se-btn-ghost"
        (click)="dupliquerDernierJour(lieu)"
        [disabled]="jours(lieu).length === 0"
      >
        Dupliquer le dernier jour
      </button>
    </div>
  </div>

  <!-- Pied -->
  <div class="se-footer">
    <button type="button" class="se-btn-outline" (click)="ajouterLieu()">
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M12 5v14M5 12h14" />
      </svg>
      Ajouter une ville
    </button>
    <span class="se-hint" *ngIf="lieux.length">{{ resume }}</span>
  </div>
</div>
<!-- ===== FIN REFONTE ===== -->
